import Reports from '../components/pages/Reports/Reports'
import Plan from '../components/pages/Reports/Plan/Plan'
import Booked from '../components/pages/Reports/Booked'
import OverallTraffic from '../components/pages/Reports/OverallTraffic/OverallTraffic'
import TranslationsTraffic from '../components/pages/Reports/TranslationsTraffic/TranslationsTraffic'

const TranslationFilters = () => import('../components/pages/Reports/Filters/TranslationFilters.vue')
const OverallTrafficFilters = () => import('../components/pages/Reports/Filters/OverallTrafficFilters.vue')
const BookedTableHead = () => import('../components/pages/Reports/TableHeads/BookedTableHead.vue')
const TrafficTableHead = () => import('../components/pages/Reports/TableHeads/TrafficTableHead.vue')

export default [
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    children: [
      {
        path: 'plan',
        name: 'reports.plan',
        component: Plan,
        meta: {
          download: true
        }
      },
      {
        path: 'booked',
        name: 'reports.booked',
        components: {
          default: Booked,
          tableHead: BookedTableHead,
          filters: TranslationFilters
        },
        meta: {
          download: true,
          search: true,
          waitForSlots: ['filters', 'tableHead'],
          hasIconfilters: true
        }
      },
      {
        path: 'sessions',
        name: 'reports.overalltraffic',
        components: {
          default: OverallTraffic,
          filters: OverallTrafficFilters
        }
      },
      {
        path: 'translations',
        name: 'reports.translationstraffic',
        components: {
          default: TranslationsTraffic,
          tableHead: TrafficTableHead,
          filters: TranslationFilters
        },
        meta: {
          download: true,
          waitForSlots: ['filters', 'tableHead']
        }
      }
    ]
  }
]
